export const calcOriginalSalePrice = (
  price: number,
  savingsPercentage: number,
) => {
  return (price / (100 - savingsPercentage)) * 100;
};
